import React from "react";
import { View } from "react-native";
import { Text } from "../../Text";
import { productAmountstyles as styles } from "./styles";
import CircularButton from "./CircularButton";
import { getLocalisedNumber, useTranslateText } from "@/app/utils/translations";

type ProductAmountProps = {
  onAdd: () => void;
  onReduce: () => void;
  quantity: number;
  minimumQuantity: number;
};

const ProductAmount = ({
  onAdd,
  onReduce,
  quantity,
  minimumQuantity,
}: ProductAmountProps) => {
  const { locale } = useTranslateText();

  return (
    <View
      style={styles.container}
      accessibilityRole="adjustable"
      accessibilityLabel="Product quantity"
      accessibilityValue={{ text: String(quantity) }}
      testID="product-quantity-container"
    >
      <View style={styles.quantityContainer}>
        <CircularButton
          disabled={quantity === minimumQuantity}
          onPress={onReduce}
        />
        <View
          style={styles.quantityTextContainer}
          accessibilityRole="text"
          accessibilityLabel="Current quantity of the product"
          testID="quantity-display"
        >
          <Text style={styles.quantityText}>
            {getLocalisedNumber(quantity, locale)}
          </Text>
        </View>
        <CircularButton disabled={false} add onPress={onAdd} />
      </View>
    </View>
  );
};

export default ProductAmount;
